var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.536 2.688a1.138 1.138 0 0 0-1.617 0l-.13.132a1.156 1.156 0 0 0 0 1.627l5.463 5.5-5.57 5.606a1.156 1.156 0 0 0 0 1.627l.131.132c.447.449 1.17.449 1.617 0L10 11.705l5.569 5.607c.446.449 1.17.449 1.616 0l.131-.132a1.156 1.156 0 0 0 0-1.627l-5.57-5.606 5.464-5.5a1.156 1.156 0 0 0 0-1.627l-.13-.131a1.138 1.138 0 0 0-1.617 0L9.999 8.188l-5.463-5.5z", fill: "#9C9C9C" })
  );
});